import { popoverThemes } from './HBPopover.styles';

export type TOpenTrigger = 'click' | 'hover';
export type HBPopoverTheme = keyof typeof popoverThemes | 'none';

export type HBPopoverPlacement = 'top' | 'bottom' | 'right' | 'left';

export enum HBPopoverOnOpenChangeTrigger {
    TargetClick = 'targetClick',
    ClickOutside = 'clickOutside',
    EnterKey = 'enterKey'
}

export interface IOnOpenChange {
    isOpen: boolean;
    triggeredFrom?: HBPopoverOnOpenChangeTrigger;
}
